
  .responsive3208187990__root .Heading3387742680__root {
    color: #000624;
  }

  /* TODO - the section with helvetica css states, shall be removed when Madefor experiment is merged along with the helvetica css state */

  .responsive3208187990__root .Heading3387742680__root.Heading3387742680---appearance-2-h1.Heading3387742680--helvetica {
      font-family: HelveticaNeueW01-75Bold, HelveticaNeueW02-75Bold, HelveticaNeueW10-75Bold, Helvetica, Arial, メイリオ, meiryo, ヒラギノ角ゴ pro w3, hiragino kaku gothic pro, sans-serif;
      font-weight: 400;
      font-size: 24px;
      line-height: 32px;
  }

  .responsive3208187990__root .Heading3387742680__root.Heading3387742680---appearance-2-h2.Heading3387742680--helvetica {
      font-family: HelveticaNeueW01-75Bold, HelveticaNeueW02-75Bold, HelveticaNeueW10-75Bold, Helvetica, Arial, メイリオ, meiryo, ヒラギノ角ゴ pro w3, hiragino kaku gothic pro, sans-serif;
      font-weight: 400;
      font-size: 22px;
      line-height: 28px;
  }

    .responsive3208187990__root .Heading3387742680__root.Heading3387742680---appearance-2-h3.Heading3387742680--helvetica {
      font-family: HelveticaNeueW01-75Bold, HelveticaNeueW02-75Bold, HelveticaNeueW10-75Bold, Helvetica, Arial, メイリオ, meiryo, ヒラギノ角ゴ pro w3, hiragino kaku gothic pro, sans-serif;
      font-weight: 400;
      font-size: 20px;
      line-height: 28px;
  }

  .responsive3208187990__root .Heading3387742680__root.Heading3387742680---appearance-2-h4.Heading3387742680--helvetica {
      font-family: HelveticaNeueW01-75Bold, HelveticaNeueW02-75Bold, HelveticaNeueW10-75Bold, Helvetica, Arial, メイリオ, meiryo, ヒラギノ角ゴ pro w3, hiragino kaku gothic pro, sans-serif;
      font-weight: 400;
      font-size: 18px;
      line-height: 24px;
  }

  .responsive3208187990__root .Heading3387742680__root.Heading3387742680---appearance-2-h5.Heading3387742680--helvetica {
      font-family: HelveticaNeueW01-75Bold, HelveticaNeueW02-75Bold, HelveticaNeueW10-75Bold, Helvetica, Arial, メイリオ, meiryo, ヒラギノ角ゴ pro w3, hiragino kaku gothic pro, sans-serif;
      font-weight: 400;
      font-size: 11px;
      line-height: 16px;
      text-transform: uppercase;
      color: #000624;
  }

  /* Madefor */

    .responsive3208187990__root .Heading3387742680__root.Heading3387742680---appearance-2-h1 {
  font-family: var(--wbu-font-stack, HelveticaNeueW01-65Medi, HelveticaNeueW02-65Medi, HelveticaNeueW10-65Medi, Helvetica, Arial, メイリオ, meiryo, ヒラギノ角ゴ pro w3, hiragino kaku gothic pro, sans-serif);
  font-weight: var(--Typography42144321-wix-font-weight-bold, 700);
  -webkit-font-smoothing: antialiased;
      font-size: 24px;
      line-height: 32px;
  }

  .responsive3208187990__root .Heading3387742680__root.Heading3387742680---appearance-2-h2 {
  font-family: var(--wbu-font-stack, HelveticaNeueW01-65Medi, HelveticaNeueW02-65Medi, HelveticaNeueW10-65Medi, Helvetica, Arial, メイリオ, meiryo, ヒラギノ角ゴ pro w3, hiragino kaku gothic pro, sans-serif);
  font-weight: var(--Typography42144321-wix-font-weight-bold, 700);
  -webkit-font-smoothing: antialiased;
    font-size: 22px;
    line-height: 28px;
  }

  .responsive3208187990__root .Heading3387742680__root.Heading3387742680---appearance-2-h3 {
  font-family: var(--wbu-font-stack, HelveticaNeueW01-65Medi, HelveticaNeueW02-65Medi, HelveticaNeueW10-65Medi, Helvetica, Arial, メイリオ, meiryo, ヒラギノ角ゴ pro w3, hiragino kaku gothic pro, sans-serif);
  font-weight: var(--Typography42144321-wix-font-weight-bold, 700);
  -webkit-font-smoothing: antialiased;
    font-size: 20px;
    line-height: 28px;
  }

  .responsive3208187990__root .Heading3387742680__root.Heading3387742680---appearance-2-h4 {
  font-family: var(--wbu-font-stack, HelveticaNeueW01-65Medi, HelveticaNeueW02-65Medi, HelveticaNeueW10-65Medi, Helvetica, Arial, メイリオ, meiryo, ヒラギノ角ゴ pro w3, hiragino kaku gothic pro, sans-serif);
  font-weight: var(--Typography42144321-wix-font-weight-bold, 700);
  -webkit-font-smoothing: antialiased;
      font-size: 18px;
      line-height: 24px;
  }

  .responsive3208187990__root .Heading3387742680__root.Heading3387742680---appearance-2-h5 {
  font-family: var(--wbu-font-stack, HelveticaNeueW01-65Medi, HelveticaNeueW02-65Medi, HelveticaNeueW10-65Medi, Helvetica, Arial, メイリオ, meiryo, ヒラギノ角ゴ pro w3, hiragino kaku gothic pro, sans-serif);
  font-weight: var(--Typography42144321-wix-font-weight-bold, 700);
  -webkit-font-smoothing: antialiased;
      font-size: 11px;
      line-height: 16px;
      text-transform: uppercase;
      color: #000624;
  }

  .responsive3208187990__root .Heading3387742680__root.Heading3387742680--light,
  .responsive3208187990__root .Heading3387742680__root.Heading3387742680--light.Heading3387742680--helvetica {
      color: #f4f5f8;
  }

/* st-namespace-reference="../../../../src/atoms/Heading/Heading.responsive.st.css" */